export const set = (key: string, value: string) => {
  localStorage.setItem(key, value)
}

export const remove = (key: string) => {
  localStorage.removeItem(key)
}

export const get = (key: string) => {
  return localStorage.getItem(key)
}

export const clear = () => {
  localStorage.clear()
}
